import type { LucideProps } from "lucide-react";
import { forwardRef } from "react";
import personFallingSvg from "../../assets/person-falling.svg";

export const FallsIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, className }, ref) => (
    <img
      ref={ref as React.Ref<HTMLImageElement>}
      src={personFallingSvg}
      width={size}
      height={size}
      className={className}
      alt="Falls"
    />
  )
);

FallsIcon.displayName = "FallsIcon";
